import { SET_SCAN_CODE } from './types';

export const setScanCode = (scanCode) => ({
  type: SET_SCAN_CODE,
  payload: scanCode,
});
